import { Badge } from '@accure/ui';

import { ContractStatus } from '../entities/contract-status';

export type ContractStatusBadgeProps = {
  status: ContractStatus | undefined;
};
export function ContractStatusBadge({ status }: ContractStatusBadgeProps) {
  switch (status) {
    case 'active':
      return (
        <Badge
          variant="default"
          className="bg-green-100 text-green-800 hover:bg-green-100"
        >
          Active
        </Badge>
      );
    case 'inactive':
      return (
        <Badge variant="secondary" className="bg-gray-100 text-gray-800">
          Inactive
        </Badge>
      );
    case 'expiring-soon':
      return (
        <Badge
          variant="destructive"
          className="bg-orange-100 text-orange-800 hover:bg-orange-100"
        >
          Expiring Soon
        </Badge>
      );
    case undefined:
      return (
        <Badge variant="secondary" className="bg-gray-100 text-gray-800">
          Not Available
        </Badge>
      );
    default:
      return null;
  }
}
